import React from 'react';
import Loading from '../../@lib/components/Loading/Loading';
import { useUIStore } from '../../store/ui';
import * as styles from './LoadingOverlay.module.css';

function LoadingOverlay() {
  const loading = useUIStore(state => state.loadingCount > 0);

  if (!loading) return null;

  return (
    <div className={styles.overlay}>
      <Loading size={56} />
    </div>
  );
}

export default LoadingOverlay;
